// 用户列表 Mock（对齐数据库用户模块设计，界面不暴露表名/字段名）
// 手机号在库中加密存储，列表一律脱敏展示

export const USER_STATUS = [
  { label: '正常', value: 1 },
  { label: '已禁用', value: 0 }
]

export const GENDER_OPTIONS = [
  { label: '未知', value: 0 },
  { label: '男', value: 1 },
  { label: '女', value: 2 }
]

export function userStatusText(status) {
  const hit = USER_STATUS.find(s => s.value === status)
  return hit ? hit.label : '未知'
}

export function userStatusTagType(status) {
  return status === 1 ? 'success' : 'info'
}

export function genderText(gender) {
  const hit = GENDER_OPTIONS.find(g => g.value === gender)
  return hit ? hit.label : '未知'
}

export const USER_LIST = [
  {
    id: 101, nickname: '塔塔得旅行日记', avatar: '', gender: 2, phone: '138****6216', real_name: '',
    region: '山东 青州', status: 1,
    post_count: 45, like_count: 2456, favorite_count: 126, follow_count: 38, fans_count: 512,
    last_login_at: '2026-09-11 08:42:15', last_login_ip: '117.136.8.102', created_at: '2026-03-12 10:24:00'
  },
  {
    id: 102, nickname: '桂林山水甲天下', avatar: '', gender: 1, phone: '189****3355', real_name: '',
    region: '广西 桂林', status: 1,
    post_count: 23, like_count: 866, favorite_count: 74, follow_count: 61, fans_count: 189,
    last_login_at: '2026-09-10 21:18:44', last_login_ip: '222.84.115.36', created_at: '2026-03-20 14:05:12'
  },
  {
    id: 103, nickname: '清风入竹', avatar: '', gender: 1, phone: '137****8890', real_name: '李明远',
    region: '浙江 杭州', status: 1,
    post_count: 12, like_count: 402, favorite_count: 58, follow_count: 24, fans_count: 96,
    last_login_at: '2026-09-11 07:03:29', last_login_ip: '112.17.44.90', created_at: '2026-04-02 09:41:37'
  },
  {
    id: 104, nickname: '南山悠然客', avatar: '', gender: 0, phone: '', real_name: '',
    region: '未知', status: 1,
    post_count: 2, like_count: 31, favorite_count: 8, follow_count: 5, fans_count: 3,
    last_login_at: '2026-08-29 16:55:02', last_login_ip: '223.104.3.71', created_at: '2026-04-15 20:12:46'
  },
  {
    id: 105, nickname: '梅子黄时雨', avatar: '', gender: 2, phone: '159****2277', real_name: '',
    region: '湖南 长沙', status: 1,
    post_count: 31, like_count: 1523, favorite_count: 210, follow_count: 47, fans_count: 356,
    last_login_at: '2026-09-10 12:30:18', last_login_ip: '39.144.107.5', created_at: '2026-04-28 11:08:53'
  },
  {
    id: 106, nickname: '塔林常客·老周', avatar: '', gender: 1, phone: '136****4408', real_name: '周建国',
    region: '广东 广州', status: 1,
    post_count: 58, like_count: 3102, favorite_count: 342, follow_count: 12, fans_count: 728,
    last_login_at: '2026-09-11 06:55:40', last_login_ip: '113.64.220.18', created_at: '2026-05-06 08:22:31'
  },
  {
    id: 107, nickname: 'Adventurer_Lin', avatar: '', gender: 1, phone: '186****7712', real_name: '',
    region: '上海 静安', status: 0,
    post_count: 0, like_count: 0, favorite_count: 2, follow_count: 1, fans_count: 0,
    last_login_at: '2026-07-02 23:41:09', last_login_ip: '101.87.36.55', created_at: '2026-05-19 23:37:02'
  },
  {
    id: 108, nickname: '稻香人家', avatar: '', gender: 2, phone: '135****9034', real_name: '',
    region: '江苏 苏州', status: 1,
    post_count: 17, like_count: 640, favorite_count: 88, follow_count: 33, fans_count: 121,
    last_login_at: '2026-09-09 19:26:33', last_login_ip: '58.211.9.140', created_at: '2026-06-01 10:14:25'
  },
  {
    id: 109, nickname: '行走的老树', avatar: '', gender: 1, phone: '150****5561', real_name: '',
    region: '四川 成都', status: 1,
    post_count: 9, like_count: 274, favorite_count: 41, follow_count: 19, fans_count: 67,
    last_login_at: '2026-09-08 09:12:57', last_login_ip: '182.150.22.84', created_at: '2026-06-10 16:48:19'
  },
  {
    id: 110, nickname: '小满未满', avatar: '', gender: 2, phone: '188****3329', real_name: '',
    region: '湖北 武汉', status: 1,
    post_count: 26, like_count: 1188, favorite_count: 156, follow_count: 52, fans_count: 243,
    last_login_at: '2026-09-10 22:47:11', last_login_ip: '27.17.88.203', created_at: '2026-06-21 13:30:44'
  },
  {
    id: 111, nickname: '桂林·接引小站', avatar: '', gender: 0, phone: '', real_name: '',
    region: '广西 桂林', status: 1,
    post_count: 3, like_count: 95, favorite_count: 12, follow_count: 0, fans_count: 208,
    last_login_at: '2026-09-11 09:01:26', last_login_ip: '222.84.115.99', created_at: '2026-07-03 09:00:00'
  },
  {
    id: 112, nickname: '云深不知处', avatar: '', gender: 1, phone: '139****6650', real_name: '',
    region: '陕西 西安', status: 0,
    post_count: 1, like_count: 6, favorite_count: 0, follow_count: 2, fans_count: 1,
    last_login_at: '2026-07-18 14:22:38', last_login_ip: '113.140.6.31', created_at: '2026-07-15 14:18:52'
  },
  {
    id: 113, nickname: '南音未歇', avatar: '', gender: 2, phone: '177****8813', real_name: '',
    region: '福建 泉州', status: 1,
    post_count: 14, like_count: 507, favorite_count: 63, follow_count: 28, fans_count: 84,
    last_login_at: '2026-09-07 11:36:20', last_login_ip: '59.57.20.146', created_at: '2026-07-28 17:09:08'
  },
  {
    id: 114, nickname: '远山淡影', avatar: '', gender: 0, phone: '133****2047', real_name: '',
    region: '云南 大理', status: 1,
    post_count: 7, like_count: 189, favorite_count: 27, follow_count: 9, fans_count: 42,
    last_login_at: '2026-09-05 20:14:03', last_login_ip: '222.220.14.75', created_at: '2026-08-09 08:55:37'
  }
]
